import PropTypes from 'prop-types';
import { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import HR from 'UIComponents/elements/HR';
import UILink from 'UIComponents/link/UILink';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import { push } from '../../actions/HistoryActions';
import { updateSelectedNavItem } from '../../actions/TemplateEditorNavigationActions';
import { NAV_ITEMS, NAV_ITEMS_WITH_NO_BREADCRUMB, NAV_ITEMS_WITH_DONE_LINK } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { SCREENS } from '../../constants/TrackingConstants';
import TemplateEditorNavigationContext from '../../records/TemplateEditorNavigationContext';
import UsageTracker from '../../utils/UsageTracker';
import { getTemplateEditorContentPath } from '../../routing/utils/internalPaths';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class ContentFormHeader extends Component {
  constructor(...args) {
    super(...args);
    this.onBreadcrumbClick = navItem => {
      const {
        location: {
          search
        }
      } = this.props;
      UsageTracker.track('templateEditorInteraction', {
        screen: SCREENS.TEMPLATE_EDITOR,
        action: 'breadcrumb-click'
      });
      this.props.updateSelectedNavItem(navItem);
      if (navItem === NAV_ITEMS.CONTENT) {
        this.props.routeChange({
          pathname: getTemplateEditorContentPath(),
          search
        });
      } else if (!NAV_ITEMS_WITH_DONE_LINK.includes(navItem)) {
        this.props.routeChange({
          pathname: getTemplateEditorContentPath(navItem),
          search
        });
      }
    };
  }
  renderDoneLink() {
    const {
      templateEditorNavigationContext: {
        navItems
      }
    } = this.props;
    const lastNavItem = navItems.get(-1);
    const targetNavItem = navItems.size > 1 ? navItems.get(-2) : lastNavItem;
    return /*#__PURE__*/_jsx(UILink, {
      onClick: () => this.onBreadcrumbClick(targetNavItem),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "knowledgeContentUI.templateEditor.sidebar.navItemsDone"
      })
    });
  }
  renderBreadcrumbs() {
    const {
      templateEditorNavigationContext: {
        navItemLabels,
        navItems
      }
    } = this.props;
    if (navItems && NAV_ITEMS_WITH_DONE_LINK.includes(navItems.get(-1))) {
      return this.renderDoneLink();
    }
    return navItems.map((item, index) => {
      if (NAV_ITEMS_WITH_NO_BREADCRUMB.includes(item)) {
        return null;
      }
      const label = navItemLabels.get(index);
      const lastIndex = navItems.size - 1;
      if (index === lastIndex) return /*#__PURE__*/_jsx("span", {
        children: label
      }, index);
      return /*#__PURE__*/_jsx(UILink, {
        onClick: () => this.onBreadcrumbClick(item),
        children: label
      }, index);
    });
  }
  render() {
    const {
      templateEditorNavigationContext: {
        navItems
      }
    } = this.props;
    if (navItems.size <= 1) {
      return null;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIBreadcrumbs, {
        className: "m-bottom-3 m-top-3 p-x-6",
        children: this.renderBreadcrumbs()
      }), /*#__PURE__*/_jsx(HR, {
        className: "m-y-0"
      })]
    });
  }
}
ContentFormHeader.propTypes = {
  location: PropTypes.object,
  routeChange: PropTypes.func.isRequired,
  templateEditorNavigationContext: PropTypes.instanceOf(TemplateEditorNavigationContext).isRequired,
  updateSelectedNavItem: PropTypes.func.isRequired
};
const mapStateToProps = ({
  templateEditorNavigationContext
}) => {
  return {
    templateEditorNavigationContext
  };
};
const mapDispatchToProps = {
  routeChange: push,
  updateSelectedNavItem
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ContentFormHeader);